import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import GroupInterestEdit    from "./GroupInterestEdit";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";

// Actions
import {
    fetchGroupInterests, deleteGroupInterest,
} from "Actions/Admin/Setup/GroupInterestActions";



/**
 * The Interest List
 */
class GroupInterestList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch(null, true);
    }

    /**
     * Fetch the content
     * @param {Object=}  params
     * @returns {Void}
     */
    fetch = (params) => {
        this.props.fetchGroupInterests(params || this.props.data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }

    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch(null, false);
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteGroupInterest(elemID);
        this.fetch(null, false);
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, route                         } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName = Utils.getValue(list, "groupinterestID", elemID, "name");

        return <Main>
            <Header message="GROUPINTERESTS_NAME" icon="interest" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="GROUPINTERESTS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="name"        message="GENERAL_NAME"       />
                        <TableHeader field="createdTime" message="GENERAL_CREATED"    maxWidth="90" hideMobile />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.groupinterestID} elemID={elem.groupinterestID}>
                            <TableCell message={elem.name}             circle={elem.statusColor} />
                            <TableCell message={elem.createdDate}      />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="EDIT"   message="GROUPINTERESTS_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="GROUPINTERESTS_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <GroupInterestEdit
                open={action.isVCE}
                elemID={elemID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="GROUPINTERESTS_DELETE_TITLE"
                message="GROUPINTERESTS_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchGroupInterests : PropTypes.func.isRequired,
        deleteGroupInterest : PropTypes.func.isRequired,
        data           : PropTypes.object.isRequired,
        route          : PropTypes.string.isRequired,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.groupinterest,
        };
    }
}

export default connect(GroupInterestList.mapStateToProps, {
    fetchGroupInterests, deleteGroupInterest,
})(GroupInterestList);

